<form [formGroup]="notesForm" (ngSubmit)="onSubmit()" autocomplete="off">
  <div class="container" style="text-align:center">
    <div class="form-row">
      <div class="col-md-2">
      </div>

      <div class="form-group col-md-3">
        <label class="col-form-label" for="appSelect">Application </label>
        <select (change)="onChange($event)" id="appSelect" class="form-control" formControlName="ApplicationId">
          <option value=''>Select One</option>
          <option *ngFor="let f of appList" [ngValue]="f.applicationId">{{f.appName}}</option>
        </select>
        <div *ngIf="ApplicationId.invalid && (ApplicationId.dirty || ApplicationId.touched)" class="alert alert-danger">
          <div *ngIf="ApplicationId.errors.required">
            Selection required.
          </div>
        </div>
      </div>

      <div class="form-group col-md-2">
        <label class="col-form-label" for="releaseDate">Release Date</label>
        <div class="input-group" autocomplete="off">
          <input maxlength="10" placeholder="yyyy-MM-dd" class="form-control" formControlName="RDate" id="releaseDate"
            ngbDatepicker #d="ngbDatepicker" (ngModelChange)="onChange($event)" autocomplete="off" required />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
          </div>
        </div>
        <div *ngIf="RDate.invalid && (RDate.dirty || RDate.touched)" class="alert alert-danger">
          <div *ngIf="RDate.errors.dateError">
            Full date required.
          </div>
        </div>
      </div>

      <div class="form-group col-md-3">
        <div class="form-row">
          <div class="form-group col-md-10">
            <label class="col-form-label" for="VersionNum">Version </label>
            <input (input)="onChange($event)" id="VersionNum" maxlength="25" class="form-control"
              formControlName="VersionNum" />
            <div *ngIf="VersionNum.invalid && (VersionNum.dirty || VersionNum.touched)" class="alert alert-danger">
              <div *ngIf="VersionNum.errors.maxlength">
                Max 25 char.
              </div>
              <div *ngIf="VersionNum.errors.required">
                Entry required.
              </div>
            </div>
          </div>
          <div class="form-group col-md-2" *ngIf="isSet">
            <label class="col-form-label" for="hotfix">Hotfix?</label>
            <input type="checkbox" class="form-control checkbox" formControlName="IsHotfix" id="hotfix" />
          </div>
        </div>
      </div>

    </div>

     <div class="form-group col-md-12" [attr.hidden]="isSet?null:'true'">
      <div id="editor">
      </div>
    </div> 
    <div class="form-group">
      <!-- <button *ngIf="isSet" [disabled]="approved" class="btn btn-save" type="submit">Save Release Notes</button> -->
      <button *ngIf="isSet && !approved" class="btn btn-save" type="submit">Save Release Notes</button>

      <!-- <button *ngIf="isSet && noteID" [disabled]="approved" class="btn btn-delete" type="button" (click)="onDelete()">
        Delete Release Notes
      </button> -->
      <button *ngIf="isSet && noteID && !approved" class="btn btn-delete" type="button" (click)="onDelete()">
        Delete Release Notes
      </button>
      
      <button *ngIf="isSet && noteID" [className]="approved?'btn btn-warning':'btn btn-success'" type="button"
        (click)="onPublish()">
        {{publishToggle}}
      </button>
    </div>
    <div>
      <button *ngIf="isSet && approved" class="btn btn-outline-dark btn-lg" type="button" (click)="sendEmail()">
        Send Email
      </button>
    </div>
  </div>
</form>
